import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Navigation from '../navigation/navigationVisiteur';
import { useNavigate } from 'react-router-dom';
import ProfilCoach from './profilCoach';

function AccueilCoach() {
  const [userData, setUserData] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const Navigate = useNavigate();

  const apiUrl = process.env.REACT_APP_API_URL;


  useEffect(() => {
    setIsLoading(true);
    const fetchData = async () => {
      try {
        const response = await axios.post(
          `${apiUrl}/verification/cookie`,
          {},
          {
            withCredentials: true 
          }
        );
        setUserData(response.data);
        setIsLoading(false);
        if (response.data.user.type !== "coach") {
          Navigate('/connexion');
        }
        setError(null);
      } catch (error) {
        if (error.response) {
            
          setError(error.response.data.message);
        } else {
       
          setError(true)
        }
        Navigate('/connexion');
        setIsLoading(false);
      }
    };
  
    fetchData();
  }, [Navigate, apiUrl]);


  if (isLoading) {
    return (
    <div className="centered-content">
      <img src="/img/logo.png" alt="Logo" className="centered-logo" />
      <br/>
      <span className="loader"></span>
    </div>
    
    );  
  }
return (
  <>
    {userData ? (
     <> 
          <ProfilCoach userData={userData}/>
      </>
    ) : (
      <>
      <Navigation/>        
      <div id="alert-message" className="alert" >
          <strong>ERROR ! </strong>{error} <span id="alert-text"></span>
      </div>
      </>
    )}
  </>
);
}

export default AccueilCoach;